module.exports = __webpack_public_path__ + "img/AGRS.aac490d0.svg";